import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import "../styles/learn-more.css";

const faqs = [
  {
    question: "What can I search in the archive?",
    answer:
      "You can search Arabic newspapers, books, magazines, and other publications from Arab American communities in North and South America.",
  },
  {
    question: "How can I narrow my search results?",
    answer:
      "Use the available filters to narrow results by year, publication, place of publication, and other document details.",
  },
  {
    question: "Can I browse instead of searching?",
    answer:
      "Yes. Use the Browse Periodicals, Browse Books, and Collections links to explore the archive without entering a search term.",
  },
  {
    question: "How do I report an issue or suggest a publication?",
    answer:
      "Email the Khayrallah Center team at lebanesestudies@ncsu.edu with questions, corrections, or publication suggestions.",
  },
];

const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="background">
        <div className="learn-more-shell">
          <button
            className="learn-more-back-button"
            onClick={() => window.history.back()}
            type="button"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Back</span>
          </button>

          <header className="learn-more-titlebar">
            <h1 className="learn-more-header">FAQ</h1>
            <hr className="line" />
          </header>

          <section className="faq-list" aria-label="Frequently asked questions">
            {faqs.map((item) => (
              <article className="faq-item" key={item.question}>
                <h2>{item.question}</h2>
                <p className="paragraph">{item.answer}</p>
              </article>
            ))}
          </section>
        </div>
      </div>
      <Footer bgcolor="#fff" />
    </>
  );
};

export default FAQ;
